var itemsPerPage = 10
var currentPage = 1

function validStr (str) {
  return str && typeof str === 'string' && str != ''
}

function isExternal (str) {
  if (!validStr(str)) return false

  return (
    str.indexOf(document.location.origin) == -1 &&
    str.indexOf(document.location.host) == -1 &&
    str[0] != '/'
  )
}

function trackExternalLinksFile () {
  var fileTypesAccepted = ['pdf']

  $('a').click(function () {
    var hrefAttr = $(this).prop('href')

    var fileType = validStr(hrefAttr) ? hrefAttr.split('.') : false
    fileType =
      fileType && fileType.length > 0 ? fileType[fileType.length - 1] : false

    // console.log( fileType );

    if (
      isExternal(hrefAttr) &&
      fileType &&
      fileTypesAccepted.indexOf(fileType) != -1
    ) {
      // console.log("ga");
      ga('send', 'event', 'PDF', 'Download Script', 'PDF Download')
    }
  })
}

$(document).ready(function () {
  trackExternalLinksFile()
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var pageGlobal = urlParams.get('page') || 0 ;
  /* js to search works on IE 11 - by Michel */
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode
  if (isIE11) {
    $('.menu__search button').click(function () {
      if ($('#search').hasClass('ie-search-style')) {
        $('#search').removeClass('ie-search-style')
        $('.header')
          .parent()
          .removeClass('marginTopSearch')
      } else {
        $('#search').addClass('ie-search-style')
        $('.header')
          .parent()
          .addClass('marginTopSearch')
      }
    })
  }

  var bodyClass = $('body').attr('class')

  /* VET-554 by Michel Martins */
  $('.button__combobox').click(function () {
    $(this)
      .parent()
      .find('.submenu-docs')
      .toggle()
  })

    // ###########################################################################
    $(document).on('click', '.speciesSelect', function (e) {

        if ($(this).is(e.target)) {

            var id = $(this).attr("id");

            // ----- Closing the other dropdown ----------
            if (id){
                if (id == "speciesDropdown"){
                    $(".speciesSelect#examinationDropdown").find('.multiselect').removeClass('open');
                    $(".speciesSelect#examinationDropdown").find('.multiselect').hide();
                    $('.background__overlay').hide();
                }

                else if (id == "examinationDropdown"){
                    $(".speciesSelect#speciesDropdown").find('.multiselect').removeClass('open');
                    $(".speciesSelect#speciesDropdown").find('.multiselect').hide();
                    $('.background__overlay').hide();
                }
            }
            // -------------------------------------------

            $(this).find('.multiselect').toggleClass('open');

            if ($(this).find('.open').length > 0) {
                $(this).find('.multiselect').show();
                $('.background__overlay').show();
            }

            else {
                $('.background__overlay').hide();

                $(this).find('.multiselect').hide();
            }
        }
    });
    // ###########################################################################

  $(window).click(function (e) {
    //$('.background__overlay').hide()
  })

  $('.speciesSelect').on('click', '.close_multiselect-wrapper', function (e) {
    e.stopPropagation()
    e.preventDefault()
    $(this)
      .parents('.speciesSelect')
      .find('.multiselect')
      .removeClass('open')

    $('.background__overlay').show()
    console.log('f')
    $(this)
      .parents('.speciesSelect')
      .find('.multiselect')
      .hide()
    $('.background__overlay').hide()
    console.log('d')
  })

  $(document).on('mouseup', function (e){
    if(e.target.tagName != "INPUT" && e.target.type != "number"){
      e.preventDefault()
      var item = $('.multiselect')
      var item2 = $('.speciesSelect')
      var item3 = $('.dropdown-menu i')
      var item4 = $('.dropdown-menu span')
      var item5 = $('.dropdown-menu')
      var item6 = $('.dropdown-menu a')
      var item7 = $('.dropdown-menu li')
      var itemDropdown = $(this).find('.dropdown')
      if (
        !item2.is(e.target) &&
        !item3.is(e.target) &&
        !item4.is(e.target) &&
        !item5.is(e.target) &&
        !item6.is(e.target) &&
        !item7.is(e.target)
      ) {
        item.hide()
        item.removeClass('open')
        $(this).find('.multiselect').hide()
        $('.background__overlay').hide()
      }
   }
  });

  $(document).on('touchend', function (e){

    var item = $('.multiselect')
    var item2 = $('.speciesSelect')
    var item3 = $('.dropdown-menu i')
    var item4 = $('.dropdown-menu span')
    var item5 = $('.dropdown-menu')
    var item6 = $('.dropdown-menu a')
    var item7 = $('.dropdown-menu li')
    var itemDropdown = $(this).find('.dropdown')

    if (
      !item2.is(e.target) &&
      !item3.is(e.target) &&
      !item4.is(e.target) &&
      !item5.is(e.target) &&
      !item6.is(e.target) &&
      !item7.is(e.target)
    ) {
      item.hide()
      item.removeClass('open')
      $(this).find('.multiselect').hide()
      $('.background__overlay').hide()
      console.log('e')
    }
  });

  /* shows complete disease relation list in specie */
  $('.link.clickExpand').click(function () {
    $('.allReports').hide()
    $('.displayNone').css('display', 'block')
    $('.specieReport').show()
  })

  /* shows complete researches in employee */
  $('.link.clickExpand').click(function () {
    $('.link.clickExpand').hide()

    $('.displayNone').css('display', 'block')

    $('div.list.list--line > aritcle.displayNone').show()
  })

  /* append class 'button' to links inside aside.box */
  if (bodyClass === 'theme-blue') {
    $('aside.box_min')
      .find('a')
      .addClass('button secondary') // blue theme
  } else {
    $('aside.box_min')
      .find('a')
      .addClass('button')
  }

  $('a')
    .find('p')
    .addClass('removePadding')

  $('.leftColumn').each(function () {
    var left = $(this)
    var right = $(this).next()

    if (right.length == 0 || right.children().length == 0) {
      left.addClass('centerColumn')
    }
  })

  $('.rightColumn').each(function () {
    var right = $(this)
    var left = $(this).prev()

    if (left.length == 0 || left.children().length == 0) {
      right.addClass('centerColumn')
    }
  })

  $('#searchBt').click(function () {
    $('#sitesearch').focus()
  })

  $('#searchTermBtn').click(function () {
    $('#search')
      .toggleClass('hide')
      .ready(
        $('#searchTerm').focus()
      )
  })

  $('#addReports').click(function () {
    $('[data-triggered-by=addReports]').toggleClass('rapport-list')
    $(this).toggleClass('hide')
  })

  // stLight.options({publisher: "0fcf7faa-988e-43c8-bb41-749df54b702a",
  //     onhover: false, doNotHash: false, doNotCopy: false, hashAddressBar: false});

  $(window).load(function () {
    // Animate loader off screen
    $('.se-pre-con').fadeOut('slow')
  })

  $(window).bind('scroll', function () {
    if ($(window).scrollTop() > $('#analysisTable').height()) {
      $('.button-total-price').hide()
    } else {
      $('.button-total-price').show()
    }
  })

  // $('body').on("click", "#findButtonUp",  function(e)
  // {
  //     var string = $("#strFinder").val();

  //     var $resultsSearch = $("body").html().find(string);
  //     // console.log($resultsSearch.length);
  //     // findString( string );
  // });

  // $('body').on("click", "#findButtonDown",  function(e)
  // {
  //     var string = $("#strFinder").val();
  //     // var strFound = window.find(string);
  //     findString( string );
  // });

  // $(".contentReport").mark("norsk");

  // the input field
  var $input = $("input[type='search']")
  var $clearBtn = $("button[data-search='clear']")
  var $prevBtn = $("a[data-search='prev']")
  var $nextBtn = $("a[data-search='next']")
  var $content = $('.contentReport')
  var $results
  var currentClass = 'current'
  var offsetTop = 50
  var currentIndex = 0
  /**
   * Jumps to the element matching the currentIndex
   */
  function jumpTo () {
    if ($results.length) {
      var currentIndexText = currentIndex + 1
      var indexText = currentIndexText + ' av ' + $results.length
      $('.nav-article__search-count').text(indexText)
      var position

      var $current = $results.eq(currentIndex)
      $results.removeClass(currentClass)
      if ($current.length) {
        $current.addClass(currentClass)
        position = $current.offset().top - offsetTop
        window.scrollTo(0, position)
      }
    }
  }

  /**
   * Searches for the entered keyword in the
   * specified context on input
   */
  $input.on('input', function () {
    var searchVal = this.value
    $content.unmark({
      done: function () {
        if (searchVal == '') $('.nav-article__search-count').text('')
        else $('.nav-article__search-count').text('0 av 0')
        $content.mark(searchVal, {
          separateWordSearch: true,
          done: function () {
            $results = $content.find('mark')
            currentIndex = 0
            jumpTo()
          }
        })
      }
    })
  })

  /**
   * Clears the search
   */
  $clearBtn.on('click', function () {
    $content.unmark()
    $input.val('').focus()
  })

  /**
   * Next and previous search jump to
   */
  $nextBtn.add($prevBtn).on('click', function () {
    if ($results !== undefined && $results.length) {
      currentIndex += $(this).is($prevBtn) ? -1 : 1
      if (currentIndex < 0) {
        currentIndex = $results.length - 1
      }
      if (currentIndex > $results.length - 1) {
        currentIndex = 0
      }
      jumpTo()
    }
  })

  $('.nav-article__list-contents')
    .find('ol')
    .each(function () {
      $(this).addClass('nav-article__list-sub-chapters')
    })

  // ####################### VET-523 - Rodrigo ###############################
  function copyToClipboard (text) {
    var $temp = $('<input>')
    $('body').append($temp)
    $temp.val(text).select()
    document.execCommand('copy')
    $temp.remove()
  }

  if ($('#copyLinkClickNews')) {
    var copyLinkTooltip = $('#copyLinkClickNews').tooltip({
      trigger: 'manual',
      placement: 'bottom',
      delay: { show: 0, hide: 100 },
      template:
        '<div class="tooltip tooltip--news-link" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
    })

    $('body').on('click', '#copyLinkClickNews', function (e) {
      e.preventDefault()
      copyToClipboard($(this).attr('href'))
      copyLinkTooltip.tooltip('show')
      setTimeout(function () {
        copyLinkTooltip.tooltip('hide')
      }, 2500)
    })
  }

  // #########################################################################

  // ############# auto search - Diego Rodrigues #############################
  $('.auto-search').each(function () {
    var $el = $(this)
    $el.autocomplete({
      source: function (request, response) {
        $.ajax({
          url: '/_/service/com.vetinst/mmmAutoZComplete?w=' + request.term,
          success: function (data) {
            response(data.data)
          }
        })
      },
      minLength: 2,
      // focus: function(event, ui)
      // {
      //     $el.val(ui.item.name);
      //     return false;
      // },
      select: function (event, ui) {
        var origEvent = event
        while (origEvent.originalEvent !== undefined) {
          origEvent = origEvent.originalEvent
        }

        if (origEvent.type == 'click') {
          $el.val(ui.item.value)
          $el.closest('form').submit()
        } else $el.closest('form').submit()

        return false
      }
    })
  })
  // #########################################################################

  $('.js-arrow-up').click(function (e) {
    e.preventDefault()
    $('html,body').animate(
      {
        scrollTop: $('header').offset().top
      },
      1000
    )
  })

  /* Scrolling */
  $(window).scroll(function () {
    var scrollTop = $(window).scrollTop()
    if (scrollTop > 200) {
      $('.arrow-up').addClass('show')
    } else {
      $('.arrow-up').removeClass('show')
    }
  })

  if (
    window.location.search &&
    window.location.search.indexOf('ex=Analysepakke') >= 0
  ) {
    $('#addAnalysepakkeFilterButton').addClass('active')
    $('#removeAnalysepakkeFilterButton').removeClass('active')
  }

  $('#addAnalysepakkeFilterButton').on('click', function (e) {
    $('#removeAnalysepakkeFilterButton').removeClass('active')
    $('#addAnalysepakkeFilterButton').addClass('active')
  })

  $('#removeAnalysepakkeFilterButton').on('click', function (e) {
    $('#addAnalysepakkeFilterButton').removeClass('active')
    $('#removeAnalysepakkeFilterButton').addClass('active')
  })

  $(window).click(function () {
    $('.button__combobox')
      .parent()
      .find('.submenu-docs')
      .hide()
  })

  $('.button__combobox').click(function (event) {
    event.stopPropagation()
  })

  $('[id^=previous_],[id^=next_]').on('click',function (event) {
    var fullUrl = new URL(window.location.href)
    var urlSearch = new URLSearchParams(fullUrl.search)
    var pageNum = Number(event.target.id.split('_')[1])

    urlSearch.set('page', pageNum)
    fullUrl.search = urlSearch.toString()
    window.location = fullUrl.toString()
  })

  $('[id^=page_num_]').click(function (event){
    var locationSearch = window.location.search;
    var queryString =  '?page='  + Number(event.target.id.split('_')[2])
    var urlParams = new URLSearchParams(locationSearch);
    var specieFilters = urlParams.get('specie')
    var diseaseFilters = urlParams.get('disease')

    if(specieFilters && specieFilters.length > 0){
        specieFilters = 'specie='+specieFilters
        queryString += '&'+specieFilters
    }

    if(diseaseFilters && diseaseFilters.length > 0){
        diseaseFilters = 'disease='+diseaseFilters
        queryString += '&'+diseaseFilters
    }

    window.location.href  = queryString
    })

    
  $('#buttonSpeciesFilter').click(function (event){
    $('#filterSpecieList').find('ul').slideToggle();
    $('#filterSpecieList').siblings().children().slideUp();

  })

  $('#buttonDiseasesFilter').click(function (event){
    $('#filterDiseaseList').find('ul').slideToggle();
    $('#filterDiseaseList').siblings().children().slideUp();
  })

  $('[id^=specie_el_]').click(function(event){
    filterArticle("specie",$(this).data().el_id)
  })
  $('[id^=desl_specie_el_]').click(function(event){
    removeFilter("specie",$(this).data().el_id)
  })


  $('[id^=disease_el_]').click(function(event){
    filterArticle("disease",$(this).data().el_id)
  })
  $('[id^=desl_disease_el_]').click(function(event){
    removeFilter("disease",$(this).data().el_id)
  })
})

function filterArticle(type,filter){
    var locationSearch = window.location.search;
    var urlParams = new URLSearchParams(locationSearch);
    var queryString = "?"


    var specieFilters = urlParams.get('specie')
    var diseaseFilter = urlParams.get('disease')

    if(type == "specie"){
        if(specieFilters && specieFilters.length > 0){
            specieFilters = specieFilters.split(',')
            specieFilters.push(filter)
        }else{
            specieFilters = filter       
        }
    }
    
    if(type == "disease"){
        if(diseaseFilter && diseaseFilter.length > 0){
            diseaseFilter = diseaseFilter.split(',')
            diseaseFilter.push(filter)
        }else{
            diseaseFilter = filter       
        }
    }
    
    if(specieFilters && specieFilters.length > 0){
        if(queryString.length > 1){
            queryString += '&'
        }
        queryString += 'specie='+specieFilters.toString()
    }
    if(diseaseFilter && diseaseFilter.length > 0){
        if(queryString.length > 1){
            queryString += '&'
        }
        queryString += 'disease='+diseaseFilter.toString()
    }

    window.location.href = queryString
}

function removeFilter(type,selected){
    
    var locationSearch = window.location.search;
    var urlParams = new URLSearchParams(locationSearch);
    var queryString = "?"


    var page_n = urlParams.get('page')
    var specieFilters = urlParams.get('specie')
    var diseaseFilter = urlParams.get('disease')

    if(type == "specie"){
        if(specieFilters && specieFilters.length > 0){
            specieFilters = specieFilters.split(',')
            specieFilters = specieFilters.filter(function(filter){ return filter != selected})
        }
    }
    
    if(type == "disease"){
        if(diseaseFilter && diseaseFilter.length > 0){
            diseaseFilter = diseaseFilter.split(',')
            diseaseFilter = diseaseFilter.filter(function(filter){ return filter != selected})
        }
    }
    
    if(page_n && page_n.length > 0){
        queryString += 'page='+ page_n
    }
    if(specieFilters && specieFilters.length > 0){
        if(queryString.length > 1){
            queryString += '&'
        }
        queryString += 'specie='+specieFilters.toString()
    }
    if(diseaseFilter && diseaseFilter.length > 0){
        if(queryString.length > 1){
            queryString += '&'
        }
        queryString += 'disease='+diseaseFilter.toString()
    }

    window.location.href = queryString
}


function replaceElements(arrayItems){
    $('.newsSection__articles--feature-article').each(function(i){ 
        if(arrayItems.length > 0){
            $(this).find("img").attr('src',arrayItems[0].big_thumbnail)
            $(this).find("a").attr('href',window.location.origin + arrayItems[0].url)
            $(this).find("a").text(arrayItems[0].title)
            $(this).show()
            arrayItems.splice(0,1)
        }else{
            $(this).hide()
        }
    })
    $('.newsSection__articles--list-article').each(function(i){ 
        if(arrayItems.length > 0){
            $(this).find("img").attr('src',arrayItems[0].big_thumbnail)
            $(this).find("a").attr('href',window.location.origin + arrayItems[0].url)
            $(this).find("a").text(arrayItems[0].title)
            $(this).show()
            arrayItems.splice(0,1)

        }else{
            $(this).hide()
        }
    })
}
function validateForm ($form) {
  var errors = []
  $form.children('input, textarea').each(function () {
    var $el = jQuery(this)
    var validations = $el.attr('data-validate').split(',')
    validations.forEach(function (v) {
      var aux = getElStatus($el, v)
      if (aux) errors.append(aux)
    })
  })
  if (errors.length > 0) return errors
  return false
}

function getElStatus ($el, validation) {
  // TODO: put this in norwegian
  switch (validation) {
    case 'required':
      if ($el.is(':text') && !$el.val()) {
        return 'The field ' + getElName($el) + ' is required.'
      }
    case 'number':
      if ($el.is(':text') && isNaN($el.val())) {
        return 'The field ' + getElName($el) + ' can only accept numbers.'
      }
  }
  return false
}

function getElName ($el) {
  return $el.attr('title') | $el.prev('label').text()
}

